export class ProductTranslate {
  name?: string;
  description?: string;
  languageCode?: string;
}
